import React from "react";
import PropTypes from "prop-types";
import styles from "./styles.css";
import HuddleIcon from "./images/huddle-logo.png";
import WhyDoYouNeedRwcCard from "../why-do-you-need-rwc-card/component";
import CarHuddleInsuranceReviewCard from "../car-huddle-insurance-review-card/component";
import starIcon from "./images/star.svg";

// eslint-disable-next-line complexity
const CarHuddleInsuranceTopSection = ({huddleBenefits, insuranceLandingData = {}, notPurchasedInsuranceData = {}, purchasedInsuranceData = {}, isInsurancePurchased, isInsuranceSubmitted, isInsuranceFailed, isInsuranceInitiated, formData }) => {
    const { title: heading = "", benefits = [] } = huddleBenefits;
    let bannerData;

    if (isInsurancePurchased) {
        bannerData = purchasedInsuranceData?.bannerData;
    } else if (isInsuranceFailed) {
        bannerData = notPurchasedInsuranceData?.bannerData;
    } else {
        bannerData = insuranceLandingData?.bannerData;
    }
    const { title = "", subTitle = "", congratulatoryText = "", iconUrl = "" } = bannerData || {};
    return (
        <div styleName={"styles.wrapper"}>
            {isInsurancePurchased && (
                <div styleName={"styles.outer"}>
                    {/* <div styleName={"styles.congratsOuter"}> */}
                    <img src={HuddleIcon} alt="Huddle Logo" />
                    <p styleName={"styles.congrats"}>{congratulatoryText}</p>
                    <p styleName={"styles.heading"}>{title}</p>
                    <p styleName={"styles.subHeading"}><img src={iconUrl} />{subTitle}</p>
                    {/* </div> */}
                </div>

            )}
            {/* {isInsuranceFailed && (
                <div styleName={"styles.outer"}>
                    <img src={HuddleIcon} alt="Huddle Logo" />
                    <p styleName={"styles.heading"}>{title}</p>
                    <p styleName={"styles.subHeading"}><img src={iconUrl} />{subTitle}</p>
                </div>
            )} */}
            {(isInsuranceInitiated || isInsuranceSubmitted || isInsuranceFailed)  && (
                <div styleName={`styles.outer ${isInsuranceInitiated ? "" : "styles.outerSmall"}`}>
                    <img src={HuddleIcon} alt="Huddle Logo" />
                    <p styleName={"styles.heading"}>{title}</p>
                    <p styleName={"styles.subHeading"}><img src={starIcon} />{subTitle}</p>
                </div>
            )}

            {(isInsuranceInitiated || isInsuranceFailed) && (
                <div styleName={"styles.cardOuter"}>
                    <p styleName={"styles.whyChooseHuddle"}>{heading}</p>
                    {benefits.map((benefit, index) => (
                        <WhyDoYouNeedRwcCard
                            key={index}
                            cardIcon={benefit.iconUrl}
                            heading={benefit.text}
                            text={benefit.subtext}
                        />
                    ))}
                </div>
            )}
            {(isInsurancePurchased || isInsuranceSubmitted) && (
                <div styleName={"styles.reviewCardOuter"}>
                    <CarHuddleInsuranceReviewCard insuranceData={isInsurancePurchased ? purchasedInsuranceData : notPurchasedInsuranceData} formData={formData}/>
                </div>
            )}

        </div>
    );
};

CarHuddleInsuranceTopSection.propTypes = {
    insuranceLandingData: PropTypes.object,
    huddleBenefits: PropTypes.object,
    insurancePurchasedData: PropTypes.object,
    orderId: PropTypes.string,
    getInsuranceDetailsConnect: PropTypes.func,
    // insuranceDetailsData: PropTypes.object,
    notPurchasedInsuranceData: PropTypes.object,
    purchasedInsuranceData: PropTypes.object,
    isInsurancePurchased: PropTypes.bool,
    isInsuranceSubmitted: PropTypes.bool,
    isInsuranceFailed: PropTypes.bool,
    isInsuranceInitiated: PropTypes.bool,
    formData: PropTypes.object
};

export default CarHuddleInsuranceTopSection;
